module.exports = __webpack_public_path__ + "img/tnt-og.0bd3a05e.jpg";